import { createBrowserRouter, Outlet, useLocation } from "react-router-dom";
import { Suspense, lazy, useEffect } from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import ProtectedRoute from "./ProtectedRoute";
import RouteLoader from "../components/common/RouteLoader";

const Home = lazy(() => import("../pages/Home"));
const Shop = lazy(() => import("../pages/Shop"));
const Men = lazy(() => import("../pages/Men"));
const Women = lazy(() => import("../pages/Women"));
const Kids = lazy(() => import("../pages/Kids"));
const About = lazy(() => import("../pages/About"));
const Contact = lazy(() => import("../pages/Contact"));
const Cart = lazy(() => import("../pages/Cart"));
const Search = lazy(() => import("../pages/Search"));
const Support = lazy(() => import("../pages/Support"));
const ViewProduct = lazy(() => import("../pages/product/ViewProduct"));
const NotFound = lazy(() => import("../pages/NotFound"));
const Login = lazy(() => import("../pages/userDashboard/Login"));
const MainDashboard = lazy(() => import("../pages/userDashboard/MainDashboard"));
const ViewOrder = lazy(() => import("../pages/userDashboard/ViewOrder"));
const ResetPassword = lazy(() => import("../pages/userDashboard/ResetPassword"));
const CheckoutFlow = lazy(() => import("../components/checkout/CheckoutFlow"));
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("../pages/TermsAndConditions"));
const ReturnPolicy = lazy(() => import("../pages/ReturnPolicy"));
const ThankYou = lazy(() => import("../pages/ThankYou"));

// Root layout component
const RootLayout = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <Suspense fallback={<RouteLoader />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/shop",
        element: <Shop />,
      },
      {
        path: "/shop/view-product/:productId",
        element: <ViewProduct />,
      },
      {
        path: "/men",
        element: <Men />,
      },
      {
        path: "/women",
        element: <Women />,
      },
      {
        path: "/kids",
        element: <Kids />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/cart",
        element: <Cart />,
      },
      {
        path: "/search",
        element: <Search />,
      },
      {
        path: "/support",
        element: <Support />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/user-dashboard",
        element: (
          <ProtectedRoute>
            <MainDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/view-order/:orderId",
        element: (
          <ProtectedRoute>
            <ViewOrder />
          </ProtectedRoute>
        ),
      },
      {
        path: "/reset-password",
        element: <ResetPassword />,
      },
      {
        path: "/order-complete",
        element: <ThankYou />,
      },
      {
        path: "/checkout",
        element: (
          <ProtectedRoute>
            <CheckoutFlow />
          </ProtectedRoute>
        ),
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/terms-and-conditions",
        element: <TermsAndConditions />,
      },
      {
        path: "/return-policy",
        element: <ReturnPolicy />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);
